const purchases = 'purchases';

export const FETCH_PURCHASES_REQUEST = `${purchases}/FETCH_PURCHASES_REQUEST` as const;
export const FETCH_PURCHASES_RESPONSE = `${purchases}/FETCH_PURCHASES_RESPONSE` as const;
